import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { MenuItem } from "../../molecules";


import inventory from "../../../assets/images/inventory.png";
import inventory2 from "../../../assets/images/inventory2.png";
import marketing from "../../../assets/images/marketing.png";
import marketing2 from "../../../assets/images/marketing2.png";
import orders from "../../../assets/images/orders.png";
import orders2 from "../../../assets/images/orders.png";
import payments from "../../../assets/images/payments.png";
import payments2 from "../../../assets/images/payments2.png";
//import settings from "../../../assets/images/settings.png";
import settings2 from "../../../assets/images/settings-alt.png";
import settings from "../../../assets/images/settings2.png";
import summary from "../../../assets/images/summary.png";
import summary2 from "../../../assets/images/summary2.png";
import timer from "../../../assets/images/timer.png";
import timer2 from "../../../assets/images/timer2.png";
import logo from "../../../assets/images/logo.svg";
import logout from "../../../assets/images/logout.png";
import { Logo2 } from "../../atoms";
import { AnalyticsService } from "../../../utils/Analytics";
import { useMediaQuery } from "react-responsive";

function Icon({ url }) {
  return <img height={24} width={24} src={url} alt="icon" />;
}

export const LeftMenu = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 900px)" });
  const navigate = useNavigate();
  const handleSignout = () => {
    const userEmail = localStorage.getItem("userEmail");
    AnalyticsService.logEvent("USER_LOGGED_OUT", {
      userEmail: userEmail,
    });
    AnalyticsService.identifyUser(null);
    localStorage.clear();
    localStorage.setItem("isAuthenticated", false);
    navigate("/");
  };
  function getIcon(path,icon1,icon2){
    if(isTabletOrMobile) return icon1;
    if(pathname === path) return icon2;
    return icon1
  }
  return (
    <div className="d-flex flex-column h-100 justify-content-between pt-3 pb-3">
      <div className={"leftMenuCls"}>
        {!isTabletOrMobile && (
          <div style={{ padding: "5px", marginBottom: "5px" }}>
            <Logo2 className="header-logo" />
          </div>
        )}
        {/* <MenuItem text={"Products"} active={pathname === "/dashboard"} 
          icon={<MdProductionQuantityLimits/>} link="/dashboard" /> */}

        <MenuItem
          text={"Summary"}
          icon={<Icon url={getIcon("/summary",summary,summary2)}/>}
          active={pathname === "/summary"}
          desktop={!isTabletOrMobile}
          link="/summary"
        />
        <MenuItem
          text={"Orders"}
          icon={<Icon url={getIcon("/orders",orders,orders2)} />}
          link={process.env.REACT_APP_TABLET_URL}
          desktop={!isTabletOrMobile}
          active={pathname === "/orders"}
        />
        <MenuItem
          text={"Inventory"}
          active={pathname === "/dashboard"}
          link="/dashboard"
          desktop={!isTabletOrMobile}
          icon={<Icon url={getIcon("/dashboard",inventory,inventory2)} />}
        />
        <MenuItem
         text={"Marketing"} 
         icon={<Icon url={getIcon("/marketing",marketing,marketing2)}/>} 
         link="/marketing"
         desktop={!isTabletOrMobile}
         active={pathname === "/marketing"} 
          /> 
        <MenuItem
          text={"Payments"}
          icon={<Icon url={getIcon("/payments",payments,payments2)} />}
          link="/payments"
          desktop={!isTabletOrMobile}
          active={pathname === "/payments"}
        />

        {/*         
        <MenuItem text={"Analytics"} icon={<Icon url={analytics}/>} />
        <MenuItem text={"Payments"} icon={<Icon url={payments}/>} />
          */}

        <MenuItem
          text={"Dispatch Times"}
          icon={<Icon url={getIcon("/timer",timer,timer2)} />}
          link={"/timer"}
          desktop={!isTabletOrMobile}
          active={pathname === "/timer"}
        />

        <MenuItem
          text={"Settings"}
          link={"/settings"}
          active={(pathname === "/settings") || (pathname=="/Merchants") }
          desktop={!isTabletOrMobile}
          icon={<Icon url={getIcon("/settings",settings2,settings)} />}
        />
        {/*<MenuItem text={"Dispatch Timer"} icon={<BiTimer/>} link="timer" active={pathname === "/timer"} />
        <MenuItem text={"Tablet App"} icon={<MdTablet/>} link={process.env.REACT_APP_TABLET_URL} />  */}
      </div>
      <div className="help-txt d-flex  click " onClick={() => handleSignout()}>
        <MenuItem text={"Logout"} icon={<Icon url={logout}   desktop={!isTabletOrMobile} />} />
      </div>
    </div>
  );
};
